import { render, staticRenderFns } from "./LeftNavMenu-Static.vue?vue&type=template&id=55b9fec0"
import script from "./LeftNavMenu-Static.vue?vue&type=script&lang=js"
export * from "./LeftNavMenu-Static.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports